<template>
  <div>
    <p class="mb-2">The contact(s) you are looking for was not found.</p>
    <v-btn
      v-if="showAddButton"
      color="appMain"
      :small="smallButton"
      @click="showModal = true"
    >
      Add Contact
    </v-btn>

    <ContactCreateModal
      v-model="showModal"
      @created="$emit('created', $event)"
      returnContact
      :search="search"
    />
  </div>
</template>

<script>
import ContactCreateModal from '@/views/contacts/components/ContactCreateModal';

export default {
  name: 'ContactNotFound',
  components: {
    ContactCreateModal,
  },
  props: {
    search: String,
    showAddButton: Boolean,
    smallButton: Boolean,
  },
  data() {
    return {
      showModal: false,
    };
  },
};
</script>
